module.exports = __webpack_public_path__ + "components/forecast-table/static/weather-forecast_sunrise-9c77bb00b2febbc4253c38f4722fb597.svg";